import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedMileageInputProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  name: string;
}

export function MaskedMileageInput({ value, onChange, name }: MaskedMileageInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    {
      mask: Number,
      thousandsSeparator: '.',
      scale: 0,
      min: 0,
      max: 999999,
    },
    {
      onAccept: (_maskedValue: string, maskRef: any) => {
        const unmasked = maskRef.unmaskedValue;
        onChange(unmasked ? Number(unmasked) : undefined);
      },
    }
  );

  useEffect(() => {
    if (value !== undefined) {
      setValue(String(value));
    }
  }, [value, setValue]);

  return <Input ref={ref} name={name} placeholder="Ex: 45.000" />;
}
